export const TemplateFiltre = `<div>
<div class="section">
  <b-collapse :open.sync="isOpen">
    <div slot="trigger" class="app-title">
      <div class="subtitle is-6">
        <b-icon icon="chevron-down" size="is-small" class="chevron_color"/>
        {{ title }}
        <a @click="deleteFilter" class="secondary-icon">
          <b-icon icon="delete-forever" size="is-normal"
            class="is-pulled-right" />
        </a>
      </div>
    </div>
    <div>
      <div :key="value.name" class="form-check"  v-for="value in values">
        <input title="filtreSelection" class="form-check-input"
               type="checkbox"
               :value='value.name'
               v-model="value.checked"
               @change="checkboxFiltres(values)"
               :id="value.name">
        <label :for="value.name" class="form-check-label">
          {{value.name}}
        </label>
      </div>
    </div>
  </b-collapse>
</div>
<hr>
</div>
`;

export function DataFiltre(key, title) {
  return () => {
    return {
      appName: 'app-' + key,
      isOpen: true,
      key,
      title,
    };
  };
}

export function ComputedFiltre(mapGetters, getterString) {
  return {
    ...mapGetters({
      getValues: getterString,
    }),
    values: {
      get() {
        return this.getValues(this.key).valeur;
      },
      set(value) {
        this.setAddFilterProperty(
          { property: this.key,
            valueProperty: { variable: this.key, valeur: value } });
      },
    },
  };
}

export function MethodsFiltre(mapMutations, mapActions,
  removeFilterProperty, addFilterProperty, actionGestionFiltre) {
  return {
    ...mapMutations({
      setRemoveFilterProperty: removeFilterProperty,
      setAddFilterProperty: addFilterProperty,
    }),
    ...mapActions({
      actionsGestionFiltres: actionGestionFiltre,
    }),
    deleteFilter() {
      this.setRemoveFilterProperty(this.key);
      this.actionsGestionFiltres();
    },
    checkboxFiltres(valeurs) {
      const valeursFilter = [];
      valeurs.forEach((valeur) => {
        if (valeur.checked) {
          valeursFilter.push(valeur.name);
        }
      });
      this.setAddFilterProperty({ property: this.key,
        valueProperty: { variable: this.key, valeur: valeursFilter, app: this.appName } });
      this.actionsGestionFiltres();
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/general/baseFiltreDynamique.js